<template>
  <div>
    <data-table class="table-custom" ref="dataTable" :option="option">
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      Status: false
    };
  },
  created() {
    const _this = this;
    //api数据集中填写
    _this.apiOptions = {
      api: "Warehouse_SupplierList",
      addApi: "Warehouse_SupplierAdd",
      editApi: "Warehouse_SupplierEdit",
      delApi: "Warehouse_SupplierDel"
    };

    //形成表格表单
    _this.option = {
      //搜索框内容
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "供应商名称",
            name: "Name",
            props: {
              placeholder: "供应商名称"
            }
          },
          {
            label: "显示禁用项",
            name: "Status",
            type: "checkbox",
            option: {
              initialValue: false
            },
            onChange: e => {
              this.Status = e.target.checked;
              this.$refs.dataTable.headSearch();
            }
          }
        ],
        onSubmitBefore: values => {
          values.Status = this.Status ? null : 1;
          // values.PageIndex = 0;
          return values;
        }
      },
      //弹出窗内容
      form: {
        title: "供应商",
        width: 900,
        content: [
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请填写名称" }]
            }
          },
          {
            label: "分类",
            name: "CategoryId",
            type: "select",
            api: "Common_GetSelect",
            param: {
              Types: "SupplierCategory"
            },
            dataField: "Data.SupplierCategory"
          },
          {
            label: "联系人",
            name: "Contacts"
          },
          {
            label: "联系方式",
            name: "TelePhone"
          },
          {
            label: "状态",
            name: "Status",
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 1,
                text: "启用"
              },
              {
                value: 0,
                text: "禁用"
              }
            ]
          },
          {
            label: "备注",
            name: "Remark",
            type: "textarea",
            colnum: 2
          }
        ],
        //新增弹窗
        add: {
          submitApi: _this.apiOptions.addApi,
          onOpenAfter: () => {
            return { Status: 1 };
          },
          onSubmitBefore: values => {
            return values;
          }
        },
        //编辑弹窗
        edit: {
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: values => {
            return values;
          },
          onSubmitBefore: values => {
            return values;
          }
        },
        del: {
          submitApi: _this.apiOptions.delApi,
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      //表格内容
      grid: {
        api: _this.apiOptions.api, //数据表格api
        params: { Status: 1 },
        props: {
          scroll: {
            y: window.document.body.clientHeight - 320
          }
        },
        columns: [
          {
            title: "序号",
            width: "5%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "供应商名称",
            dataIndex: "Name",
            width: "15%",
            align: "center"
          },
          {
            title: "供应商分类",
            dataIndex: "CategoryName",
            width: "10%",
            align: "center"
          },
          {
            title: "状态",
            width: "10%",
            dataIndex: "StatusName",
            align: "center"
          },
          {
            title: "联系人",
            width: "10%",
            dataIndex: "Contacts",
            align: "center"
          },
          {
            title: "联系方式",
            width: "10%",
            dataIndex: "TelePhone",
            align: "center"
          },
          {
            title: "备注",
            dataIndex: "Remark",
            align: "left"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "150px",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ],
        pageChange: json => {
          return {
            ...json,
            Status: this.Status ? null : 1
          };
        }
      }
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.table-custom {
  /deep/ .head {
    /deep/ .head-search-box {
      /deep/ .ant-form-item-label {
        width: 140px;
      }
    }
  }
}
</style>
